
<script>
import Aviatickets from './Aviatickets.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'
import arrowIcon from '@/assets/images/icons/arrow-down.svg?inline'

export default {
  name: 'flights',
  components: {
    Aviatickets,
    infiniteScroll,
    arrowIcon
  },
  props: {
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    active: false
  }),
  computed: {
    flight() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    isCollectionLoading() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    pagination() {
      return this.$store.getters['cart/getFlightPagination'](this.flightIndex)
    },
    flightTitle() {
      let title = null

      if (this.flight.collection.length) {
        const flight = this.flight.collection[0]
        const directions = flight.directions
        const firsSegment = flight.directions[0].segments[0]

        title = directions.reduce((str, direction) => {
          const segmentsLength = direction.segments.length
          const lastSegment = direction.segments[segmentsLength - 1]

          return `${str} - ${lastSegment.arrival.city.slug}`
        }, '')

        title = `${firsSegment.departure.city.slug} ${title}`
      }

      return title
    }
  },
  methods: {
    loadMore(type) {
      if (type !== 'search') {
        this.$store.commit('cart/updateIsCollectionLoading', {
          flightIndex: this.flightIndex,
          status: true
        })
      }

      this.$store.dispatch('cart/getFlights', {
        flightIndex: this.flightIndex,
        form: {
          ...this.$store.getters['cart/getFlightFormForSearch'](this.flightIndex),
          page: type === 'search' ? 1 : this.pagination.page + 1
        }
      })
    },
    toggleTourFlights() {
      this.active = !this.active
    }
  }
}
</script>

<template>
  <div>
    <div
      v-if="mainServiceIsTours"
      class="cart__aviatickets-tour-header"
    >
      <h3>{{ flightTitle }}</h3>
      <div class="cart__aviatickets-tour-header--row-btn">
        <div
          class="cart__aviatickets-tour-header--btn"
          @click="toggleTourFlights"
        >
          <arrowIcon
            fill="#2b2b2b"
            class="cart__aviatickets-tour-header--arrow-icon"
            :class="{ 'cart__aviatickets-tour-header--arrow-icon-rotate': active }"
          />
        </div>
      </div>
    </div>
    <infinite-scroll
      v-if="resultIsShown || (active && mainServiceIsTours)"
      :pagination="pagination"
      :is-loading="flight.isCollectionLoading || flight.isLoading"
      @loadMore="loadMore"
    >
      <template>
        <aviatickets
          :flight-index="flightIndex"
        />
      </template>
    </infinite-scroll>
  </div>
</template>
